export default {
      id: "trustpilot-usage",
      viewBox: "0 0 111 28",
      url: __webpack_public_path__ + "sprite.svg#trustpilot",
      toString: function () {
        return this.url;
      }
    }